(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('dispositivo-os', {
            parent: 'entity',
            url: '/dispositivo-os',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.dispositivo_os.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dispositivo-os/dispositivo-os.html',
                    controller: 'Dispositivo_osController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dispositivo_os');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dispositivo-os-detail', {
            parent: 'entity',
            url: '/dispositivo-os/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.dispositivo_os.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dispositivo-os/dispositivo-os-detail.html',
                    controller: 'Dispositivo_osDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dispositivo_os');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Dispositivo_os', function($stateParams, Dispositivo_os) {
                    return Dispositivo_os.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'dispositivo-os',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('dispositivo-os-detail.edit', {
            parent: 'dispositivo-os-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dispositivo-os/dispositivo-os-dialog.html',
                    controller: 'Dispositivo_osDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Dispositivo_os', function(Dispositivo_os) {
                            return Dispositivo_os.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dispositivo-os.new', {
            parent: 'dispositivo-os',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dispositivo-os/dispositivo-os-dialog.html',
                    controller: 'Dispositivo_osDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                os: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dispositivo-os', null, { reload: 'dispositivo-os' });
                }, function() {
                    $state.go('dispositivo-os');
                });
            }]
        })
        .state('dispositivo-os.edit', {
            parent: 'dispositivo-os',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dispositivo-os/dispositivo-os-dialog.html',
                    controller: 'Dispositivo_osDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Dispositivo_os', function(Dispositivo_os) {
                            return Dispositivo_os.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dispositivo-os', null, { reload: 'dispositivo-os' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dispositivo-os.delete', {
            parent: 'dispositivo-os',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dispositivo-os/dispositivo-os-delete-dialog.html',
                    controller: 'Dispositivo_osDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Dispositivo_os', function(Dispositivo_os) {
                            return Dispositivo_os.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dispositivo-os', null, { reload: 'dispositivo-os' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
